import React from 'react';
import LoginForm from '../../components/auth/LoginForm/LoginForm';

const Login = ({}) => (
    <LoginForm />
)

export default Login;